var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComponent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4988_1555)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.358887,
    y: 5.5,
    width: 10,
    height: 10,
    stroke: "#11788F",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.85889,
    y: 7,
    width: 7,
    height: 7,
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.8589,
    width: 5,
    height: 5,
    fill: "#11788F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4988_1555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
export default __webpack_public_path__ + "static/media/component.9cac4f835b6ad57624421f1f7705db24.svg";
export { ForwardRef as ReactComponent };